// extracted by mini-css-extract-plugin
export var modalBox = "y_vg";
export var backdrop = "y_vh";